import { CTAButton } from '@gamma/ui/buttons';
import {
  CardPageBackButton,
  CardPageCTA,
  CardPageHeading,
  CardPageIllustration,
  CardPageSubtitle,
} from '@gamma/ui/pages';
import { useEffect } from 'react';
import { useNavigate, useOutletContext } from 'react-router';
import { i18n } from '../../../../../shared/localization';

import { IForgotPasswordContext } from '../ForgotPassword';

export const Complete = () => {
  const navigate = useNavigate();
  const { userEmail } = useOutletContext<IForgotPasswordContext>();

  useEffect(() => {
    if (!userEmail) {
      navigate('/login', { replace: true });
    }
  }, [userEmail]);

  const { title, subtitle, cta } = i18n.pages.forgotPassword.complete;

  return (
    <>
      <CardPageBackButton onClick={() => navigate('/login/trouble')} />
      <CardPageHeading>{title}</CardPageHeading>
      <CardPageIllustration illustration={'CheckOnlyComplete'} />
      <CardPageSubtitle>{subtitle}</CardPageSubtitle>
      <CardPageCTA>
        <CTAButton onClick={() => navigate('/login', { replace: true })}>
          {cta}
        </CTAButton>
      </CardPageCTA>
    </>
  );
};
